import { H1, H2, H3 } from "../../styles/type/headings";
import { AssistiveText } from "../../styles/type/typography";
import { ContentContain } from "../../styles/layout/contain";

const CookiesContent = () => {
	return (
		<>
			<ContentContain flushTop small>
				<H1 small>Hello edun.</H1>
				<H1>Cookie Policy.</H1>
				<AssistiveText pushTop>Last Updated: 27/02/2024</AssistiveText>
				<p>
					At Edun, accessible from https://www.helloedun.co.uk, we prioritize your privacy and are committed to being transparent about the technologies we use. This Cookie Policy explains
					how and why cookies and similar technologies may be stored on and accessed from your device when you use or visit our website.
				</p>
				<H2>What are Cookies?</H2>
				<p>
					Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to enhance your online experience, enabling features
					like keeping you logged in or remembering your site preferences.
				</p>
				<H2>Use of Cookies</H2>
				<p>
					We use cookies for several reasons, as detailed below. While there is no standard method to opt out of cookies without affecting the functionalities they support, you can manage
					them in your browser settings.
				</p>
				<H2>Disabling Cookies</H2>
				<p>
					You can change your browser settings to decline cookies if you prefer. However, please note that disabling cookies may impact the functionality and features of our site, as well as
					other websites you visit.
				</p>
				<H2>Types of Cookies We Use</H2>
				<H3>Login-Related Cookies:</H3>
				<p>
					These cookies help us remember your login status, so you don&apos;t have to log in repeatedly as you navigate through our site. They are removed or cleared when you log out or they
					expire, ensuring access to restricted features and areas only while logged in.
				</p>
				<H3>Site Preferences Cookies:</H3>
				<p>To provide a personalized experience, we set cookies that remember your preferences for how our site behaves or looks during your visit.</p>
				<H3>Third-Party Cookies:</H3>
				<p>Third-Party Cookies: In some special cases, we use cookies provided by trusted third parties to support new features or services on our website. There are not tracking cookies.</p>
				<H2>More Information</H2>
				<p>We hope this policy clarifies our use of cookies. If you have any questions or require further information, please do not hesitate to contact us.</p>
				<p>
					Email: <a href="mailto:info@helloedun.co.uk">info@helloedun.co.uk</a>
				</p>
			</ContentContain>
		</>
	);
};

export default CookiesContent;
